import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Background: pure white in light mode, subtle elevation in
        // dark mode (4% white tint sits clearly above bg-background /
        // bg-card without going full white-on-dark which kills text
        // contrast). Fixes the "input boxes blend into the dialog"
        // complaint from Feb 28, 2026.
        "flex h-9 w-full rounded-md border border-input bg-white dark:bg-white/[0.06] px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
